import React, { useId } from 'react';
import styles from './forms.module.scss';
import { ConfigProvider, Input } from 'antd';
import { antdTheme as theme } from 'shared/constants';
import classNames from 'classnames';
import { IconButton } from '../buttons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleX } from '@fortawesome/pro-solid-svg-icons';

/**
 * @typedef {import('antd').InputProps & {
 *    label?: string,
 *    error?: string,
 *    hideErrorText?: boolean,
 *    size?: 'small' | 'middle' | 'large',
 *    noMarginBottom?: boolean,
 *    inputStyle?: string,
 *    wrapperClass?: string,
 *    small?: boolean,
 *    touched?: boolean,
 *    ref?: import('react').Ref<import('antd').InputRef>,
 * }} TextInputProps
 */

/**
 * @param {TextInputProps} param0
 * @returns
 */
export function TextInput({
  label = null,
  error = null,
  hideErrorText = false,
  size = 'large',
  disabled = false,
  placeholder = '',
  noMarginBottom = false,
  allowClear = false,
  name,
  id,
  ...props
}) {
  const generatedId = useId();
  const inputId = id || generatedId;
  const labelString = typeof label === 'string' ? label : '';

  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            borderRadius: 8,
            colorBorder: theme.colorBorder,
            colorTextPlaceholder: theme.colorTextPlaceholder,
            fontSizeLG: 14,
            controlHeightLG: 48,
          },
        },
      }}>
      <div className={classNames(styles.root, { [styles.noMarginBottom]: noMarginBottom })}>
        {label && <label htmlFor={inputId}>{label}</label>}
        <Input
          id={inputId}
          name={name}
          status={error && 'error'}
          placeholder={disabled ? '' : placeholder}
          disabled={disabled}
          size={size}
          {...props}
          allowClear={
            allowClear
              ? {
                  clearIcon: (
                    <IconButton label={`Clear ${labelString}`} type="button">
                      <FontAwesomeIcon icon={faCircleX} size="md" />
                    </IconButton>
                  ),
                }
              : false
          }
        />
        {!hideErrorText && <span className={styles.error}>{error}</span>}
      </div>
    </ConfigProvider>
  );
}
